import { CSSProperties } from 'react';
import { NotificationCounter } from '../../common/components/notification-counter';
import { getNavigationNotificationsStyle } from './helpers';

export function FrExportsNotificationsCounter({
    notificationCount,
    style,
}: {
    notificationCount: number;
    style?: CSSProperties;
}) {
    return (
        <NotificationCounter
            button="exports"
            style={{
                ...getNavigationNotificationsStyle(notificationCount),
                ...style,
            }}
        >
            {notificationCount}
        </NotificationCounter>
    );
}
